enum BillingCycleEnum {
	Weekly = 'weekly',
	Monthly = 'monthly',
}

export default BillingCycleEnum;
